import React from 'react';
import { Modal } from "@mui/material";
import Fade from '@mui/material/Fade';

import View from '@modul-connect/shared/components/atoms/view'
import { H1, P } from '@modul-connect/shared/components/atoms/text'
import Button from '@modul-connect/shared/components/atoms/button';
import modal from '@modul-connect/shared/components/atoms/modal'


const ModalAlert = ({
    openModal,
    onClose,
    header,
    content,
    modalStyle
}) => {
    return (
        <Modal
            open={ openModal }
            onClose={() => onClose() }
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            <Fade in={ openModal }>
                <div >
                    <View extend={ modalStyle || modal.container }>
                        <View extend={ modal.header }>
                            <H1 text={ header }/>
                        </View>
                        <View extend={ modal.content }>
                            <P>{ content }</P>
                        </View>
                        <View extend={ modal.footer }>
                            <Button noBg onClick={ () => onClose() }>
                                Ok
                            </Button>
                        </View>
                    </View>
                </div>
            </Fade>
        </Modal>
    )
}

export default ModalAlert;